export const ShopRouter = [
    {
        path: '/',
        redirect: { path: 'config/record-app' },
    },
    // As rotas apontam para os switchers, nao direto para o iframe do reborn: a
    // versao nova (ShopReborn.vue) so vale para contas com a flag `new_shop`; as
    // demais seguem nas telas antigas (V3).
    {
        path: 'config/record-app',
        component: () => import('@/modules/shop/components/Apps/RecordApp.vue'),
        name: 'recordApp',
    },
    {
        path: 'config/smart-approach',
        component: () => import('@/modules/shop/components/Apps/SmartApproachApp.vue'),
        name: 'smartApproachApp',
    },
];
